import {Component, Inject, OnInit} from '@angular/core';
import {IddTraining} from '../../../shared/interface/idd-training';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface AddIddTrainingCertificateData {
  iddTrainingObject: IddTraining;
}

@Component({
  selector: 'app-add-idd-training-certificate-dialog',
  templateUrl: './add-idd-training-certificate-dialog.component.html',
  styleUrls: ['./add-idd-training-certificate-dialog.component.scss']
})
export class AddIddTrainingCertificateDialogComponent implements OnInit {
  iddTrainingObject: IddTraining;

  constructor(
    public dialogRef: MatDialogRef<AddIddTrainingCertificateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddIddTrainingCertificateData,
  ) {
    this.iddTrainingObject = data.iddTrainingObject;
  }

  ngOnInit(): void {
  }

}
